import React from "react";
import SimpleReactValidator from "simple-react-validator";

export const userRegisterValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "لطفا آدرس را به طور کامل بنویسید",
        max: "بیشتر از 120 کاراکتر نباید باشد",
    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
});

export const adminLoginValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "کمتر از 6 کاراکتر نباید باشد",
        max: "بیشتر از 25 کاراکتر نباید باشد",
        email: "ایمیل نامعتبر است",
    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
});

export const adminRegisterValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "کمتر از 6 کاراکتر نباید باشد",
        max: "بیشتر از 25 کاراکتر نباید باشد",
        email: "ایمیل نامعتبر است"
    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})

export const areaValidatior = () => new SimpleReactValidator({
	messages: {
		required: "پرکردن این فیلد الزامی می باشد",
	},
	element: (message) => <div className="text-danger my-1 text-center col-12 pe-0 ps-1">{message}</div>,
})

export const jobCategoryValidatior = () => new SimpleReactValidator({
	messages: {
		required: "پرکردن این فیلد الزامی می باشد",
	},
	element: (message) => <div className="text-danger my-1 text-center col-12 pe-0 ps-1">{message}</div>,
})

export const placeCategoryValidatior = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})

export const placeValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        integer: "باید به صورت عدد باشد",
        numeric: "باید به صورت عددی باشد",
        min: "کمتر از 15 کاراکتر نباید باشد",
        phone: "فرمت شماره تلفن اشتباه وارد شده است",
        url: "فرمت لینک اشتباه است"

    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})
export const orderValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        integer: "باید به صورت عدد باشد",
        numeric: "باید به صورت عددی باشد",
        min: "کمتر از 15 کاراکتر نباید باشد",
        phone: "فرمت شماره تلفن اشتباه وارد شده است",

    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})


export const userInfoValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "کمتر از 6 کاراکتر نباید باشد",
        max: "بیشتر از 25 کاراکتر نباید باشد",
        integer: "باید به صورت عدد باشد",
        phone: "فرمت شماره تلفن اشتباه است"
    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})


export const discountValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "کمتر از 6 کاراکتر نباید باشد",
        integer: "باید به صورت عددی باشد"

    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})

export const commentValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "کمتر از 10 کاراکتر نباید باشد",
        max: "بیشتر از 255 کاراکتر نباید باشد",
    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})

export const mobileNumberValidator = () => new SimpleReactValidator({
	messages: {
		required: "پرکردن این فیلد الزامی می باشد",
		min: "شماره موبایل صحیح نمی باشد",
		max: "شماره موبایل صحیح نمی باشد",
	},
	element: (message) => <div className="text-danger my-1 text-center col-12 pe-0 ps-1">{message}</div>,
})

export const verificationCodeValidator = () => new SimpleReactValidator({
	messages: {
		required: "کد تایید را وارد کنید",
		max: "کد تایید اشتباه است",
		min: "کد تایید صحیح نیست",
	},
	element: (message) => <div className="text-danger my-1 text-center col-12 pe-0 ps-1">{message}</div>,
})

export const productValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        integer: "باید به صورت عدد باشد",
        numeric: "باید به صورت عددی باشد",
        min: "کمتر از 5 کاراکتر نباید باشد",
        phone: "فرمت شماره تلفن اشتباه است",
        url: "فرمت لینک اشتباه است"

    },
    element: (message) => <div className="text-danger my-1 col-12 pe-0 ps-1">{message}</div>,
})

export const shoppingCartValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        integer: "باید به صورت عدد باشد",
        max: "بیشتر از 25 کاراکتر نباید باشد",
        phone: "فرمت شماره تلفن اشتباه است"
        
    },
    element: (message) => <div className="text-danger my-1 text-left col-12 pe-0 ps-1">{message}</div>,
})

export const personValidator = () => new SimpleReactValidator({
    messages: {
        required: "پر کردن این فیلد الزامیست",
        min: "کمتر از 6 کاراکتر نباید باشد",
        max: "بیشتر از 55 کاراکتر نباید باشد",
        url: "فرمت url اشتباه است",
        email: "ایمیل نامعتبر است",
        integer: "باید به صورت عدد باشد",
        regex: "از اعداد و حروف انگلیسی استفاده کنید",
        numeric: "باید به صورت رقم یا اعشار باشد",
        phone: "فرمت شماره تلفن اشتباه است"

    },
    element: (message) => <div className="text-danger col-12 pe-0 ps-1" style={{marginTop:'3px'}}>{message}</div>,
})